import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-popupClose",
  "use": "icon-popupClose-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-popupClose\">\n<g id=\"icon-popupClose_Group 427324315\">\n<rect id=\"icon-popupClose_Rectangle 5163\" x=\"10.9287\" y=\"12.3433\" width=\"2\" height=\"18\" transform=\"rotate(-45 10.9287 12.3433)\" fill=\"#03FF00\" />\n<rect id=\"icon-popupClose_Rectangle 5164\" x=\"12.3433\" y=\"25.0713\" width=\"2\" height=\"18\" transform=\"rotate(-135 12.3433 25.0713)\" fill=\"#03FF00\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol